export function injectLegacyScript(source)
{
    if (!source) {
        return;
    }

    var script = document.createElement('script');

    script.type = 'text/javascript';
    script.text = source;
    document.head.appendChild(script);
    document.head.removeChild(script);
}

export function injectLegacyScripts(sources)
{
    sources.forEach(injectLegacyScript);
}
